<template>
    <div>
        <div class="table-style table-style--default">
            <div class="table-style__row">
                <div class="table-style__th">문의 제목</div>
                <div class="table-style__td">
                    <v-text-field v-model="question.subject" outlined persistent-placeholder hide-details />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">문의 내용</div>
                <div class="table-style__td">
                    <v-textarea v-model="question.content" outlined persistent-placeholder hide-details rows="8" />
                </div>
            </div>
        </div>

        <div class="mt-20px mt-md-30px">
            <v-row align="center" class="row--x-small">
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-row align="center" class="row--x-small">
                        <v-col cols="auto">
                            <v-btn large outlined color="grey" dark @click="cancel"><span class="grey--text text--darken-3">취소</span></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn large color="primary" @click="save">등록</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
	components: {
	},
    data() {
        return {
            files: [{ name: "" },{ name: "" },{ name: "" }],
            fileName: "",
            question: {
                _id: this.$route.params._question,
                type: null,
                subject: null,
                content: null,
            },
            questionTypes: [
                "회원정보 문의",
                "주문/결제 문의",
                "상품 문의",
                "배송 문의",
                "교환/반품 문의",
                "이벤트/혜택 문의",
                "서비스 개선 의견",
                "기타문의"
            ]
        }
    },
    async mounted(){
        await this.init();
    },
	methods: {
        async init(){
            if(this.question._id){
                let { question } = await api.v1.me.center.questions.get({ _id: this.$route.params._question });
                this.question = question;
            }
        },
        fileChange(index){
            this.files[index].name = event.target.files[0].name;
        },
        cancel(){
            this.$router.go(-1);
        },
        validate(){
            try{
                var question = this.question;
                // if(!question.type) throw new Error("문의유형을 선택해주세요");
                if(!question.subject) throw new Error("문의제목을 입력해주세요");
                if(!question.content) throw new Error("문의내용을 입력해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            if(this.validate()){
                this.question._id ? await api.v1.me.center.questions.put(this.question) : await api.v1.me.center.questions.post(this.question);
                alert("상담문의가 저장되었습니다");
                this.$router.go(-1);
            }
        },
	},
}
</script>
